'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _session = require('../../session');

var _session2 = _interopRequireDefault(_session);

var _dashboard = require('./dashboard');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _invitations = require('./invitations');

var _invitations2 = _interopRequireDefault(_invitations);

var _adjudicators = require('./adjudicators');

var _adjudicators2 = _interopRequireDefault(_adjudicators);

var _trainings = require('./trainings');

var _trainings2 = _interopRequireDefault(_trainings);

var _schools = require('./schools');

var _schools2 = _interopRequireDefault(_schools);

var _editAccounts = require('./edit-accounts');

var _editAccounts2 = _interopRequireDefault(_editAccounts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes.admin', ['ui.router', 'ngMaterial', 'ifeis.session', 'ifeis.routes.admin.dashboard', 'ifeis.routes.admin.invitations', 'ifeis.routes.admin.adjudicators', 'ifeis.routes.admin.schools', 'ifeis.routes.admin.trainings', 'ifeis.routes.admin.edit-accounts']).config(function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('admin', {
    url: '/admin',
    abstract: true,
    template: require('./tpl.html'),
    resolve: {
      isAdmin: function isAdmin(fSession, $q) {
        return fSession.user().then(function () {
          if (fSession.isGod()) {
            return true;
          } else {
            return $q.reject(false);
          }
        });
      }
    },
    controller: function controller($scope, $state, $timeout, $mdSidenav, $log) {

      function goFn(state) {
        return function goToState() {
          $mdSidenav('left').close();
          return $state.go('admin.' + state);
        };
      }

      $scope.tiles = [{
        label: 'Invitations',
        background: 'red',
        icon: 'plus-circle',
        flex: 50,
        go: goFn('invitations')
      }, {
        label: 'Schools',
        background: 'pink',
        icon: 'graduation-cap',
        go: goFn('schools')
      }, {
        label: 'Adjudicators',
        background: 'purple',
        icon: 'gavel',
        go: goFn('adjudicators')
      }, {
        label: 'Manage Training Resources',
        background: 'red',
        icon: 'graduation-cap',
        go: goFn('trainings')
      }, {
        label: 'Edit Accounts',
        background: 'orange',
        icon: 'user',
        go: goFn('edit-accounts')
      }, { label: 'Finance', background: 'orange', icon: 'money' }, { label: 'Feiseanna', background: 'green', icon: 'list' }, { label: 'Personnel', background: 'indigo', icon: 'key' }, { label: 'Teachers', background: 'blue', icon: 'user' }];

      $scope.close = function () {
        // Component lookup should always be available since we are not using `ng-if`
        $mdSidenav('left').close().then(function () {
          $log.debug("close LEFT is done");
        });
      };
    }
  });

  $urlRouterProvider.when('/admin', '/admin/dashboard');
}).run(function ($state, $rootScope) {
  $rootScope.$on('$stateChangeError', function (event, toState) {
    if (toState.name.indexOf('admin') === 0) {
      $state.go('check-auth', {}, { location: false });
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/admin/index.js
// module id = 514
// module chunks = 0